import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Image from 'reusecore/src/elements/Image';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import JoinTrailArea, { ContentWrapper, ButtonGroup } from './joinTrail.style';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';

import {
  GActions,
  GLabels,
  sendEvent
} from 'common/src/hooks/googleEvents';

const JoinTrail = ({
  buttonWrapper,
  fillButton,
  button
}) => {
  const data = useStaticQuery(graphql`
    query {
      appClassicJson {
        joinSlack {
          logo {
            publicURL
          }
          title
          description
        }
      }
    }
  `);
  const { logo, title, description } = data.appClassicJson.joinSlack;

  return (
    <JoinTrailArea id="trail">
      <ContentWrapper>
        {/* <Fade up>
          <Image src={logo.publicURL} alt="Slack" />
        </Fade>
        <Fade up delay={100}>
          <Heading content={title} />
        </Fade> */}
        <Fade up delay={200}>
          <h1><Text content="Ready to add chat?" /></h1>
        </Fade>
        <Fade up delay={300}>
          <Box {...buttonWrapper}>
            <a href="https://console.fizz.io">
              <Button style={{ fontWeight: '700' }}
                {...fillButton}
                title="START FREE"
              />
            </a>
            <a href="http://bit.ly/fizzreqaccess">
              <Button style={{ fontWeight: '700' }} {...fillButton} title="CONTACT SALES" />
            </a>
          </Box>
        </Fade>
      </ContentWrapper>
    </JoinTrailArea>
  );
};

JoinTrail.propTypes = {
  buttonWrapper: PropTypes.object,
  button: PropTypes.object,
};

JoinTrail.defaultProps = {
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'space-around',
    mt: '35px',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '800',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '150px'],
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
  button: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    color: '#fff',
    colors: 'secondary',
    height: ['40px', '46px'],
    minHeight: 'auto',
  }
}

export default JoinTrail;
